import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { ArrowDropDown, Done } from '@mui/icons-material';

import { useDispatch, useSelector } from 'store';

import { selectWorkspace } from 'store/slices/workspace';

const menuitemStyle = {
    width: '100%',
    maxWidth: '300px',
    display: 'flex',
    flexDirection:'column',
    margin: '0 8px',
    '&.Mui-selected': {
        bgcolor: '#FDFAFF',
        '&:hover': {
            bgcolor: '#FDFAFF',
        }
    },
    '&:hover': {
        bgcolor: '#FDFAFF'
    }
};

const optionTitleStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    maxWidth: '300px',
    marginBottom: '8px'
};

const Workspace = ({ workspaceId, handleChangeWorkspace }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { workspaces } = useSelector((state) => state.workspace);

    const [selected, setSelected] = useState(null);

    useEffect(() => {
        // if(workspaces.filter(w => w.id === workspaceId) != null && workspaces.filter(w => w.id === workspaceId).length != 0) {
            setSelected(workspaceId)
            dispatch(selectWorkspace(workspaces.filter(w => w.id === workspaceId)?.[0]));
        // } else {
            // navigate('/404')
        // }
    }, [workspaces, workspaceId]);

    const changeWorkspace = (val) => {
        setSelected(val)
        dispatch(selectWorkspace(workspaces.filter(w => w.id === val)?.[0]));
        handleChangeWorkspace(val)
    }

    const getWorkspaceName = (val) => {
        let name = null;
        workspaces.forEach((workspace, index) => {
            if (workspace.id === val) {
                name = workspace.name
            }
        })

        return name;
    }

    return (
        <FormControl variant="standard" sx={{ m: 1, width: '100%', margin: '0 !important' }}>
            <Select
                id="workspace-list"
                value={selected}
                sx={{
                    width: '100%',
                    '&.MuiOutlinedInput-root': {
                        fieldset: {
                            borderColor: 'transparent'
                        },
                        div: {
                            bgcolor: '#FFFFFF99',
                            paddingLeft: '0 !important'
                        },
                        '&:hover fieldset': {
                            borderColor: 'transparent'
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: 'transparent'
                        },
                    },
                    '& .MuiSelect-select': {
                        padding: '12px 0 12px 24px'
                    },
                    '& .MuiSvgIcon-root': {
                        color: '#5A1C70'
                    }
                }}
                disableUnderline
                IconComponent={ArrowDropDown}
                renderValue={
                    () =>
                        <Typography
                            sx={{
                                fontSize: '20px',
                                fontWeight: 700,
                                fontFamily: 'Gilroy-Bold',
                                color: '#79418D'
                            }}
                        >
                            {getWorkspaceName(selected)}
                        </Typography>
                }
                onChange={(e) => {
                    changeWorkspace(e.target.value);
                }}
            >
                {workspaces && workspaces.map((workspace, index) => (
                    <MenuItem key={index} value={workspace.id} sx={menuitemStyle}>
                        <Box sx={{...optionTitleStyle}}>
                            <Typography sx={{ flex: 1, fontSize: '14px', fontWeight: 700, color: '#2D2D2D' }}>
                                {workspace.name}
                            </Typography>
                            {workspace.id === selected && <Done sx={{ width: '20px', height: '20px', color: '#5A1C70' }} />}
                        </Box>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
};

export default Workspace;
